import { useMemo } from 'react'
import { useLocation, useParams } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { InvoiceEditorUrlParams } from '../../../types/invoiceEditorUrlParams'
import { DEFAULT_INVOICE_EDITOR_VARIANT } from '../constants/variants/defaultInvoiceEditorVariant'
import { invoiceEditorVariantRoutes } from '../constants/variants/invoiceEditorVariantRoutes'

export const useInvoiceEditorVariant = () => {
  const { organization } = useUserOrganization()
  const { pathname } = useLocation()
  const { documentId } = useParams<InvoiceEditorUrlParams>()

  const invoiceEditorVariant = useMemo(() => {
    if (!organization?.url) {
      return DEFAULT_INVOICE_EDITOR_VARIANT
    }

    return (
      invoiceEditorVariantRoutes.find((route) => pathname === route.getVariantRoute(organization.url, documentId))
        ?.variant || DEFAULT_INVOICE_EDITOR_VARIANT
    )
  }, [organization?.url, pathname, documentId])

  return { invoiceEditorVariant }
}
